import { CheckoutCard } from '@dtk/ui-components';
import { storyblokEditable } from '@storyblok/react';

export const CheckoutCardBlok = ({ ...props }) => {
  const { blok } = props;
  return <CheckoutCard {...storyblokEditable(blok)} {...blok} />;
};
